export const getAllPromotion = '/vouchers';
export const addPromotion = '/vouchers';
export const getPromotionDetails = '/vouchers/';
export const updatePromotion = '/vouchers/';
export const updatePromotionStatus = '/vouchers/update-status/';
